import { createMiddleware } from "@tanstack/react-start";
import { getHeaders } from "@tanstack/react-start/server";
import { Effect } from "effect";
import { AuthService, type AuthSession } from "~/lib/server/auth";

export const authMiddleware = createMiddleware({ type: "function" }).server(
	async ({ next }) => {
		const auth = await Effect.runPromise(
			Effect.gen(function* () {
				const auth = yield* AuthService;
				const session = yield* Effect.tryPromise(() =>
					auth.api.getSession({
						headers: getHeaders() as unknown as Headers,
					}),
				);

				if (!session) {
					return {
						isAuthenticated: false,
						user: null,
						session: null,
					} as AuthSession;
				}

				return {
					isAuthenticated: true,
					user: session.user,
					session: session.session,
				} as AuthSession;
			}).pipe(
				Effect.withSpan("auth-middleware"),
				Effect.provide(AuthService.Default),
			),
		);

		return next({ context: { auth } });
	},
);
